import {ReviewApprovedIcon} from '@github-ui/custom-icons/ReviewApprovedIcon'
import {ReviewState, type CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

import {ForYouItem} from '../shared/ForYouItem'
import {useReviewData} from './use-review-data'
import {useOverviewBranchActions} from '../mergeability/shared/use-overview-branch-actions'

export function shouldShowReviewApproved(review: CompletedReview | null | undefined): review is CompletedReview {
  return review?.state === ReviewState.APPROVED
}

export function ReviewApproved() {
  const branchActions = useOverviewBranchActions('review-approved')
  const {data: review, queryStatus} = useReviewData()

  if (queryStatus !== 'success' || !shouldShowReviewApproved(review)) return null

  return (
    <ForYouItem
      itemId="review-approved"
      visual={{kind: 'icon', icon: ReviewApprovedIcon, tone: 'success', glyphSize: 16}}
      title="Review submitted"
      subText="You're all set, thanks for your time!"
      actions={branchActions}
    />
  )
}
